<template>
    <div id="new-income-sources-module" class="vx-col w-full mb-5">
        <PersonalOccupationInformation :isFromSupplier="true" :project="source" @updated="getProjectData"></PersonalOccupationInformation>
        <vs-divider></vs-divider>
        <PersonalEmploymentInformation :isFromSupplier="true" :project="source" @updated="getProjectData"></PersonalEmploymentInformation>
        <vs-divider></vs-divider>
        <PersonalIncomeSourceInformation :isFromSupplier="true" :project="source" @updated="getProjectData"></PersonalIncomeSourceInformation>
        <vs-divider></vs-divider>
        <NewIncomeSourceProofs :incomeSources="source.client.user.personal.p_p_income_sources" :applicantUserId="source.client.user.id" @updated="getProjectData"></NewIncomeSourceProofs>

    </div>
</template>

<script>
import PersonalEmploymentInformation from '../../../../views/applicant/loan-requests/components/PersonalEmploymentInformation.vue';
import PersonalIncomeSourceInformation from '../../../../views/applicant/loan-requests/components/PersonalIncomeSourceInformation.vue';
import PersonalOccupationInformation from '../../../../views/applicant/loan-requests/components/PersonalOccupationInformation.vue';
import NewIncomeSourceProofs from './NewIncomeSourceProofs.vue';

export default {
    name: 'NewIncomeSourcesModule',
    components: {
        PersonalEmploymentInformation,
        PersonalIncomeSourceInformation,
        PersonalOccupationInformation,
        NewIncomeSourceProofs
    },
    data: () => ({
        
    }),
    props: {
        source: Object
    },
    methods: {
        getProjectData() {
            this.$emit('updated', 1);
        }
    },
}
</script>